import React from "react";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import TagIcon from "@mui/icons-material/Tag";
import ListItemText from "@mui/material/ListItemText";
import Skeleton from "@mui/material/Skeleton";

import { SideBlock } from "./SideBlock";

export const TagsBlock = ({
  items,
  isLoading = true,
  onClickTag,
  selectedTag,
}) => {
  return (
    <SideBlock title="Tags">
      <List>
        {(isLoading ? [...Array(5)] : items)
          .filter((name) => name)
          .map((name, i) => (
            <ListItem key={i} disablePadding>
              <ListItemButton
                component="a"
                href={`/tags/${name}`}
                selected={selectedTag === name}
                onClick={(e) => {
                  e.preventDefault();
                  onClickTag(name);
                }}
              >
                <ListItemIcon>
                  <TagIcon />
                </ListItemIcon>
                {isLoading ? (
                  <Skeleton width={100} />
                ) : (
                  <ListItemText primary={name} />
                )}
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </SideBlock>
  );
};
